import { takeLatest } from 'redux-saga/effects';
import { UserInfoSaga, UserRoleAccessSaga } from './saga';
import * as ActionTypes from './ActionTypes';

export default function* UserRoleAccess() {
    yield takeLatest(ActionTypes.USER_ROLE_ACCESS_REQUEST, UserRoleAccessSaga);
    yield takeLatest(ActionTypes.USER_INFO_REQUEST, UserInfoSaga);
}

